import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { SpinnerButtonComponent } from "../../../common/components/spinnerButton";
import { LocalizationService } from "../../../common/services/localization";
import { ClientService } from "../../../common/services/client.service";
import { getSafeRedirectUrl } from "../../../common/helpers/redirect.helper";
import { isOneWebSessionCookieEnabled, mintOneWebSessionCookie } from "../../../common/helpers/oneWebSession.helper";
import storage from "../../../common/storage";

@Component({
    selector: "verify-code",
    template: require("./verify-code.component.html").default,
    styles: [
        require("../../../common/styles/index.scss").default,
        require("./verify-code.component.scss").default,
        require("../home-page.scss").default,
    ],
})
export class VerifyCodeComponent implements OnInit, OnDestroy {
    @ViewChild("spinnerButton") spinnerButton: SpinnerButtonComponent;

    invalidEmailOrPhoneNumber = false;
    tooManyAttempts = false;
    tokenExpired = false;
    spondIsOffline = false;
    token = "";
    phoneNumber = "";
    redirectUrl = "";
    updateNoteInterval = null;
    noteCountDown = 55;
    resendNote = "";
    hasResent = false;
    showResendCode = false;

    model = {
        verifyCode: { invalid: false, value: "" },
    };

    constructor(
        public i18n: LocalizationService,
        private client: ClientService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.token = params["token"];
            this.phoneNumber = params["phoneNumber"];
            this.redirectUrl = params["redirectUrl"];
        });

        this.resendNote = this.i18n.get("register_validate_note_2");
        this.updateNoteInterval = setInterval(() => {
            this.noteCountDown--;

            if (this.noteCountDown > 0) {
                if (this.noteCountDown <= 40) {
                    this.resendNote = this.i18n.get("register_validate_note_2") + `&nbsp;(${this.noteCountDown})`;
                } else {
                    this.resendNote = this.i18n.get("register_validate_note_2");
                }
            } else if (!this.hasResent) {
                this.resendNote =
                    this.i18n.get("register_validate_note_2") +
                    "\n" +
                    this.i18n.get("register_validate_note_not_recieved_code");
                this.showResendCode = true;
            } else {
                this.showResendCode = false;
                this.resendNote = this.i18n.get("register_validate_contact_support_note");
            }
        }, 1000);
    }

    ngOnDestroy() {
        if (this.updateNoteInterval) {
            clearInterval(this.updateNoteInterval);
        }
    }

    handleError(err) {
        this.spondIsOffline = false;
        this.model.verifyCode.invalid = false;
        const errorBody = err._body ? JSON.parse(err._body) : {};

        if (err.status === 503) {
            this.spondIsOffline = true;
        } else if (errorBody.errorKey === "outOfLoginAttempts") {
            this.tooManyAttempts = true;
        } else if (errorBody.errorKey === "invalidPromptToken") {
            this.tokenExpired = true;
        } else {
            this.model.verifyCode.invalid = true;
        }
    }

    onResendCodeClicked() {
        this.client.resendCode(this.token).subscribe(
            (res: any) => {
                this.noteCountDown = 55;
                this.hasResent = true;
                this.showResendCode = false;
                this.token = res.token;
            },
            (err) => {
                this.handleError(err);
            },
        );
    }

    submit() {
        const verifyCode = this.model.verifyCode;

        this.spinnerButton.isSpinning = true;
        this.client.verify2fa(this.token, verifyCode.value, this.phoneNumber).subscribe(
            async (data: any) => {
                if (data.accessToken?.token) {
                    storage.setItem("token", data.accessToken.token);
                    storage.setItem("tokenExpiration", data.accessToken.expiration);
                    storage.setItem("refreshToken", data.refreshToken.token);
                    storage.setItem("refreshTokenExpiration", data.refreshToken.expiration);
                }
                if (await isOneWebSessionCookieEnabled()) {
                    await mintOneWebSessionCookie(data);
                }
                const safeRedirectUrl = getSafeRedirectUrl(this.redirectUrl);
                if (safeRedirectUrl) {
                    window.location.href = safeRedirectUrl;
                } else {
                    this.redirectToClient();
                }
            },
            (err) => {
                this.handleError(err);
                this.spinnerButton.isSpinning = false;
            },
        );
    }

    private redirectToClient() {
        window.location.href = "/client";
    }
}
